import React from "react";
import { Navigate } from "react-router-dom";
import { useUserDataContext } from "../../../user_data_context";
import { APPLICATION_ROUTES } from "../../../common/utils/routes";
import SpinnerLoader from "../../../common/components/loaders/spinner_loader";

/**
 * Blocks direct access to Notes routes for unauthenticated users. Waits for the auth check
 * to finish before deciding, so logged-in users are not bounced on a hard refresh while the
 * session is still loading.
 */
const NotesRouteGuard = ({ children }: { children: React.ReactNode }) => {
	const { userData, isAuthChecked } = useUserDataContext();

	if (!isAuthChecked) {
		return (
			<div className="relative z-[2] flex items-center justify-center w-full h-full bg-white dark:bg-bg-page">
				<SpinnerLoader />
			</div>
		);
	}

	if (!userData?._id) return <Navigate to={APPLICATION_ROUTES.HOME} replace />;

	return <>{children}</>;
};

export default NotesRouteGuard;
